import React, { useEffect, useState, useRef } from "react"
import Image from "@/components/Shared/Image"
import Link from "next/link"
import { useTranslation } from "next-i18next"
import { NumericFormat } from "react-number-format"

import { getTranslations } from "@/components/Bundles/localization"

import { getPDPUrl, sanitizeTextForAnalytics } from "@/utils/helper"
import { getPdpRedirectUrl } from "@/utils/"

import { getConfig } from "@/constants/config"
import _get from "lodash/get"

import { addCartItemSummaryAnalytics } from "@/components/cart/cartAnalytics"

import Style from "@/components/Bundles/StaticBundle/BundlesViewDetails/BundleChildItems/index.module.scss"

const BundleChildItems = props => {
  const { data = {}, pdpView = false, page = "" } = props
  const { t } = useTranslation("common")
  const {
    colorOrFinish = "",
    qty = 0,
    cannotShipLabel,
    outOfStockLabel,
  } = getTranslations(t)
  const [productPdpUrl, setProductPdpUrl] = useState("")

  const siteName = useRef(null)

  const {
    name = "",
    desc = "",
    sku = "",
    category = "",
    slug = "",
    image = "",
    color = "",
    quantity = 0,
    currencySign = "$",
    totalPrice = 0,
    unitPrice = 0,
    discountedPrice = 0,
    noShipping = false,
    outOfStock = false,
  } = data

  const productName = name ? `${name} ${!pdpView ? desc : ""}` : desc

  useEffect(() => {
    if (category && slug && sku) {
      getPDPUrl(category, slug).then(pdpUrl => {
        const param = sku ? `skuId=${sku}` : ""
        const redirectUrl = getPdpRedirectUrl(pdpUrl, param)
        setProductPdpUrl(redirectUrl)
      })
    }
  }, [category, slug, sku])

  useEffect(() => {
    getConfig().then(config => {
      siteName.current = _get(config, "general.siteName", "")
    })
  }, [])
  const customerFacingSKUId = data.customerFacingSKU || data.sku

  const cartItemProductInfo = JSON.stringify({
    productInfo: {
      productBrand: siteName.current?.toLowerCase(),
      description: sanitizeTextForAnalytics(data.desc),
      globalPromotionPrice: Number(data.discountedPrice)
        ? Number(data.discountedPrice)
        : Number(data.unitPrice),
      priceState:
        data.discountPercent > 0
          ? "percentOff|" + data.discountPercent
          : "regular price",
      productBasePrice: Number(data.unitPrice),
      productCategory: sanitizeTextForAnalytics(data.category),
      productColor: sanitizeTextForAnalytics(data.color) || "n/a",
      productID: customerFacingSKUId,
      productName: sanitizeTextForAnalytics(data.name),
      productRoom: sanitizeTextForAnalytics(data.category),
      productSalePrice: Number(data.discountedPrice)
        ? Number(data.discountedPrice)
        : Number(data.unitPrice),
      productStatus:
        data.outOfStock && data.availableQty < 1 ? "out of stock" : "in stock",
      productSuperSku: data.superSku ? true : false,
      productTileName: sanitizeTextForAnalytics(data.name),
      quantity: data.quantity,
      defaultImageName: data.image,
      productCollectionsName: sanitizeTextForAnalytics(
        data.productCollectionsName || data.category
      ),
      productCoupondiscount: "n/a",
      productPartnerBuyNow: "true",
      productSaleable: "true",
      isRecommended: "true",
      isSendNow: "true",
      isSubscription: "true",
      frequency: "n/a",
      ratings: "n/a",
      numberOfReviews: "n/a",
      pdpType: "bundle",
      productFindingMethod: "n/a",
    },
  })
  const productPrice = discountedPrice ? discountedPrice : unitPrice

  return (
    <div className={Style.ChildItems}>
      <div className="image">
        <Link
          href={productPdpUrl}
          data-gbh-data-layer-custom={cartItemProductInfo}
          data-gbh-data-layer={addCartItemSummaryAnalytics(
            page,
            data.desc,
            data.name,
            productPdpUrl,
            true
          )}
          className="gbh-data-layer"
        >
          <Image src={image} alt={productName} fill />
        </Link>
      </div>
      <div className="information-section">
        <Link
          href={productPdpUrl}
          className="list-title gbh-data-layer"
          data-gbh-data-layer-custom={cartItemProductInfo}
          data-gbh-data-layer={addCartItemSummaryAnalytics(
            page,
            data.desc,
            data.name,
            productPdpUrl,
            true
          )}
        >
          {productName}
        </Link>
        <ul className="attributes">
          <li>
            {colorOrFinish}:<span className="attributes-details">{color}</span>
          </li>
          <li>
            {qty}:<span className="attributes-details">{quantity}</span>
            {pdpView ? (
              <div className="price-group mobile">
                <p className="price">
                  <NumericFormat
                    value={unitPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={currencySign}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </p>
                {discountedPrice ? (
                  <p className="linethrough">
                    {currencySign}
                    {unitPrice}
                  </p>
                ) : null}
              </div>
            ) : null}
            <span className="preview-cart-bundle-price">
              <span className="price-divider">/</span>
              <NumericFormat
                value={totalPrice}
                displayType={"text"}
                thousandSeparator={true}
                prefix={currencySign}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </span>
          </li>
        </ul>
        {noShipping ? (
          <div className="cart-item__stock-msg --error">
            <span>{cannotShipLabel}</span>
          </div>
        ) : null}
        {outOfStock ? <div className="error">{outOfStockLabel}</div> : null}
      </div>
      {pdpView ? (
        <div className="price-group">
          <p className="price">
            <NumericFormat
              value={productPrice}
              displayType={"text"}
              thousandSeparator={true}
              prefix={currencySign}
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </p>

          {discountedPrice ? (
            <p className="linethrough">
              {currencySign}
              {unitPrice}
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default BundleChildItems
